module.exports = __webpack_public_path__ + "static/media/burger-icon.98b5df0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/topMenu/burger-icon.svg
// module id = 28
// module chunks = 0